import requestor from "shared/service/requestor";
import ChapterApi from "./chapter.api";
import CommentApi from "./comment.api";
import GroupApi from "./group.api";
import HomeworkInstanceApi from "./homeworkInstance.api";
import LessonApi from "./lesson.api";
import StudentApi from "./student.api";
import SurveyInstanceApi from "./surveyInstance.api";
import TestInstanceApi from "./testInstance.api";
import TreeNodeApi from "./treeNode.api";

export default class CourseApi {
  constructor(isManage = false) {
    this.isManage = isManage;
    this.namespace = isManage ? '/manage/course_' : '/course/';
  }

  all = () => requestor.get(this.namespace + "all");
  one = (id) => requestor.get(this.namespace + "one", { course_id: id });
  item = ({ courseId, lessonId }) => requestor.get(this.namespace + "item", { course_id: courseId, lesson_id: lessonId });
  create = (name) => requestor.post(this.namespace + "create", { name: name });
  save = (id, form) => requestor.patch(this.namespace + "save", { course_id: id, Course: form });
  delete = (id) => requestor.delete(this.namespace + "delete", { course_id: id });
  toggle = (id) => requestor.patch(this.namespace + "toggle", { course_id: id });
  copy = (id) => requestor.put(this.namespace + "copy", { course_id: id });
  startSelling = (id, price) => requestor.post(this.namespace + "start_selling", { course_id: id, price: price });

  get chapter() {
    if (!this._chapterApi) {
      this._chapterApi = new ChapterApi(this.isManage);
    }
    return this._chapterApi;
  }

  get comment() {
    if (!this._commentApi) {
      this._commentApi = new CommentApi(this.isManage);
    }
    return this._commentApi;
  }

  get group() {
    if (!this._groupApi) {
      this._groupApi = new GroupApi(this.isManage);
    }
    return this._groupApi;
  }

  get homeworkInstance() {
    if (!this._homeworkInstanceApi) {
      this._homeworkInstanceApi = new HomeworkInstanceApi(this.isManage);
    }
    return this._homeworkInstanceApi;
  }

  get lesson() {
    if (!this._lessonApi) {
      this._lessonApi = new LessonApi(this.isManage);
    }
    return this._lessonApi;
  }

  get student() {
    if (!this._studentApi) {
      this._studentApi = new StudentApi(this.isManage);
    }
    return this._studentApi;
  }

  get surveyInstance() {
    if (!this._surveyInstanceApi) {
      this._surveyInstanceApi = new SurveyInstanceApi(this.isManage);
    }
    return this._surveyInstanceApi;
  }

  get testInstance() {
    if (!this._testInstanceApi) {
      this._testInstanceApi = new TestInstanceApi(this.isManage);
    }
    return this._testInstanceApi;
  }

  get treeNode() {
    if (!this._treeNodeApi) {
      this._treeNodeApi = new TreeNodeApi(this.isManage);
    }
    return this._treeNodeApi;
  }
}
